module.exports = __webpack_public_path__ + "img/2026big15.4c36c4aa.png";